import { Component, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../service/proveedores/proveedores.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable, startWith } from 'rxjs';
import { CuentasService } from '../../../app/service/cuentas/cuentas.service';

@Component({
  selector: 'app-descargar-pendiente-alta-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './descargar-pendiente-alta-dialog.component.html',
  styleUrl: './descargar-pendiente-alta-dialog.component.scss'
})
export class DescargarPendienteAltaDialogComponent {

  proveedor
  cuentas = []
  estatusSelected = ''
  estatusForm: FormGroup
  estatusId


  filteredOptions: Observable<string[]>;
  calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);
  hoveredDate: NgbDate | null = null;
  toDate: NgbDate | null = this.calendar.getToday();
  fromDate: NgbDate | null = this.calendar.getPrev(this.calendar.getToday(), 'd', 10);
  displayMonths: number = 1;
  
  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data: any,
      private fb: FormBuilder,
      private cuentasService: CuentasService,
      public dialogRef: MatDialogRef<DescargarPendienteAltaDialogComponent>) {
        this.estatusForm = this.fb.group({
          estatus: ['', [Validators.required]],
          observacion: ['', [Validators.required]],
          tipoCuenta: ['', [Validators.required]]
        })

        this.getCuentas()
  }

  ngOnInit() {
    
  }

  getCuentas(){
    this.cuentasService.tiposCuenta().subscribe(
      data => {
         this.cuentas = data
      }
    )  
  }

  closeDialog() {
    this.dialogRef.close({event: 2});
  }

  save(){
    this.dialogRef.close({event: 1});
  }

  guardarCambios(){
    this.dialogRef.close({event: 1, proveedor: this.estatusForm.get('tipoCuenta').value, fechaInicial: this.fromDate, fechaFinal: this.toDate})
  }

  // Metodos para el correcto funcionamiento del picker
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }


  openPanelOnFocus(event: any): void {

  }

  async cambioInput($event){

  }
  validarDescarga(){

    if(this.toDate !== null && this.fromDate !== null){
      return false
    }else{
      return true
    }
  }
}